import { z } from 'zod';
import { v4PageOf } from '../__shared__/page.schemas.ts';
import { seasonFlatSchema, seasonSchema } from '../season/schemas.ts';
import { BreakdownType } from './constants.ts';

const propertyListItemSchema = z.object({
  id: z.string(),
  organization_id: z.string(),
  name: z.string()
});

export const getPropertiesResponseSchema = z.object({
  data: z.array(propertyListItemSchema)
});

const currentSeasonAreaSchema = z.object({
  areaId: z.string(),
  areaInHectares: z.number(),
  cropId: z.string(),
  emergencyDate: z.string().nullable(),
  id: z.string(),
  methodologyId: z.string().nullable(),
  plantingDate: z.string(),
  seasonId: z.string(),
  varieties: z.array(z.string()),
  varietyName: z.string(),
  endsAt: z.string(),
  startsAt: z.string(),
  harvestingDate: z.string().nullable().optional(),
  deleted: z.boolean().nullable().optional()
});

export const currentSeasonAreasResponseSchema = z.array(currentSeasonAreaSchema);

const v1RegionSchema = z.object({
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
  id: z.string(),
  name: z.string(),
  parentId: z.string().nullable(),
  propertyId: z.string()
});

export const regionsByPropertyResponseSchema = z.array(v1RegionSchema);

export const seasonsByPropertyResponseSchema = v4PageOf(seasonFlatSchema);

export const diagnosticBreakdownSchema = z.object({
  acceptance: z.number(),
  control: z.number(),
  damage: z.number(),
  undetermined: z.number(),
  spray: z.number().optional(),
  valid_on: z.string(),
  breakdown_type: z.nativeEnum(BreakdownType)
});

export const propertySchema = z.object({
  id: z.string(),
  name: z.string(),
  company_id: z.string(),
  root_region_id: z.string(),
  seasons: z.array(seasonSchema).optional(),
  last_visit: z.number().optional(),
  total_area: z.number().optional(),
  area_count: z.number().optional(),
  diagnostic_breakdown: diagnosticBreakdownSchema.optional(),
  country: z.string().optional()
});

const legacyPageEnvelope = z.object({
  number: z.number(),
  size: z.number(),
  pages: z.number(),
  total: z.number(),
  mutableContent: z.array(propertySchema)
});

export const propertyBasicInfoResponseSchema = z.union([legacyPageEnvelope, z.array(propertySchema)]);

const referencePointSchema = z.object({
  type: z.string(),
  coordinates: z.array(z.number())
});

export const propertyInfoAddressDTOSchema = z.object({
  address: z.string().nullable(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  created_at: z.string(),
  created_by_id: z.string().nullable(),
  crn: z.string(),
  deleted: z.boolean(),
  fields_updated_at: z.string().nullable(),
  id: z.string(),
  last_updated_by_id: z.string().nullable(),
  name: z.string(),
  org_id: z.string(),
  place_id: z.string().nullable(),
  reference_point: referencePointSchema,
  regulatory_zone: z.string().nullable(),
  root_region_id: z.string(),
  state: z.string().nullable(),
  time_zone: z.string(),
  updated_at: z.string(),
  wait_response: z.boolean(),
  zip_code: z.string().nullable()
});

export const propertyTimeSchema = z.object({
  currentDateTimeUTC: z.string(),
  timeZone: z.string(),
  referencePoint: referencePointSchema
});
